// import React, { useState, useContext, useEffect } from "react";
// import Dropdown from "./Dropdown";
// import Popup from "./Popup";
// import Table from "./Table";
// import ProfileLabel from "./ProfileLabel";
// import InputBox from "./InputBox";
// import DateBox from "./DateBox";
// import NumberBox from "./NumberBox";
// import Textarea from "./Textarea";
// import Button from "./Button";
// import {
// 	timesheetTableHead,
// 	timesheetTableBody,
// 	TimesheetWorkModel,
// } from "../data";
// import { TIMESHEET } from "../Constants";
// import { TIMESHEETEDIT } from "../Constants";
// import ApiCall from "../utils/ApiCall";
// import AuthContext from "../contexts/AuthContext";
// import SweetAlert from "../utils/SweetAlert";
// import Loader from "./Loader";

// const Timesheet = () => {
// 	const { authTokens, user } = useContext(AuthContext);
// 	const [currentDate] = useState(getFormattedDate());
// 	const [loading, setLoading] = useState(true);
// 	const [btnLoader, setBtnLoader] = useState(false);
// 	const [btnLoaderEdit, setBtnLoaderEdit] = useState(false);
// 	const [selectedProject, setSelectedProject] = useState("");
// 	const [selectedManager, setSelectedManager] = useState("");
// 	const [selectedWorkModel, setSelectedWorkModel] = useState("");
// 	const [selectedStatus, setSelectedStatus] = useState("");
// 	const [selectedDate, setSelectedDate] = useState("");
// 	const [selectedHours, setSelectedHours] = useState("");
// 	const [selectedStartTime, setSelectedStartTime] = useState("");
// 	const [selectedEndTime, setSelectedEndTime] = useState("");
// 	//const [formData, setFormData] = useState([]);
// 	const [ButtonPopup, setButtonPopup] = useState(false);
// 	const [editPopup, setEditPopup] = useState(null);
// 	const [timesheetDetails, setTimesheetDetails] = useState([]);
// 	const [timesheetProjects, setTimesheetProjects] = useState([]);
// 	const [dropDownValue, setDropdownValue] = useState(null);
// 	const [textName, setTextName] = useState("");
// 	const [editFormData, setEditFormData] = useState([]);
// 	const [selectedId, setSelectedId] = useState(" ");
// 	const [nonProductiveHours, setNonProductiveHours] = useState(0);

// 	useEffect(() => {
// 		fetchData();
// 		setTimesheetProjects([]);
// 	}, []);

// 	const fetchData = async () => {
// 		try {
// 			const data = await ApiCall(TIMESHEET, "GET", authTokens, null);
// 			// console.log("hhfsdhfsjfkkds", data.data);
// 			setTimesheetDetails(data.data.timesheet_data);
// 			// console.log("Details", timesheetDetails);
// 			setTimesheetProjects(data.data.projects);
// 			setSelectedId(data.id);
// 			// console.log("timeid",data.id)
// 			// console.log("data",data.data.projects,data.data.timesheet_data,data.id);
// 			setLoading(false);
// 		} catch (error) {
// 			console.log("Error fetching data", error);
// 			setLoading(false);
// 		}
// 	};

// 	function getFormattedDate() {
// 		const date = new Date();
// 		const year = date.getFullYear();
// 		let month = date.getMonth() + 1;
// 		let day = date.getDate();

// 		month = month < 10 ? `0${month}` : month;
// 		day = day < 10 ? `0${day}` : day;

// 		return `${year}-${month}-${day}`;
// 	}

// 	const handleStartTimeChange = (event) => {
// 		const time = event.target.value;
// 		setSelectedStartTime(time);
// 	};

// 	const handleEndTimeChange = (event) => {
// 		const time = event.target.value;
// 		setSelectedEndTime(time);
// 	};

// 	const addTimeSheet = () => {
// 		setButtonPopup(true);
// 	};

// 	const handleSave = async (event) => {
// 		event.preventDefault();
// 		setBtnLoader(true);

// 		// if (
// 		// 	!selectedProject ||
// 		// 	!selectedStartTime ||
// 		// 	!selectedEndTime ||
// 		// 	!selectedHours ||
// 		// 	!selectedStatus
// 		// ) {
// 		// 	//  console.log("error",selectedManager)
// 		// 	SweetAlert({
// 		// 		title: "Please fill all required fields before saving.",
// 		// 		icon: "error",
// 		// 	});
// 		// 	return;
// 		// }

// 		const params = {
// 			project_name: selectedProject,
// 			project_manager:
// 				selectedProject === "nonproductive" ? "None" : selectedManager,
// 			work_mode: selectedWorkModel,
// 			date: currentDate,
// 			start_time: selectedStartTime,
// 			end_time: selectedEndTime,
// 			logged_hours: selectedHours,
// 			status: selectedStatus,
// 			// other: selectedProject === "other" ? textName : null,
// 			non_productive_hrs: nonProductiveHours,
// 		};

// 		// console.log("timesheet sfs", params);
// 		//let res = { status: -1 };
// 		try {
// 			const res = await ApiCall(TIMESHEET, "POST", authTokens, params);
// 			//console.log(res.data.message);
// 			// console.log("get methods sfs", res);
// 			await fetchData();
// 			if (res.status === 200) {
// 				SweetAlert({ title: res.data.message, icon: "success" });
// 			} else if (res.status === 409) {
// 				SweetAlert({
// 					title: res.data.message,
// 					icon: "error",
// 				});
// 			} else {
// 				SweetAlert({ title: "Something went wrong", icon: "error" });
// 			}
// 		} catch (error) {
// 			console.log("Error fetching data", error);
// 		}
// 		setBtnLoader(false);
// 		setButtonPopup(false);
// 		setSelectedProject("");
// 		//setTextName("");
// 		fetchData();
// 	};

// 	const handleSaveEdit = async (event) => {
// 		event.preventDefault();
// 		setBtnLoaderEdit(true);
// 		const params = {
// 			id: selectedId,
// 			project_name: selectedProject,
// 			project_manager:
// 				selectedProject === "nonproductive"
// 					? "None"
// 					: selectedProject === "others"
// 					? textName
// 					: selectedManager,
// 			work_mode: selectedWorkModel,
// 			date: selectedDate,
// 			start_time: selectedStartTime,
// 			end_time: selectedEndTime,
// 			logged_hours: selectedHours,
// 			status: selectedStatus,
// 			// other: textName,
// 			non_productive_hrs: nonProductiveHours,
// 		};

// 		// console.log("non productive", nonProductiveHours);
// 		// setTimesheetFilled(true);

// 		try {
// 			const res = await ApiCall(TIMESHEETEDIT, "POST", authTokens, params);
// 			setButtonPopup(false);
// 			if (res.status === 200) {
// 				SweetAlert({ title: "Edited timesheet added", icon: "success" });
// 			} else {
// 				SweetAlert({ title: "Something went wrong", icon: "error" });
// 			}
// 			//console.log(res.data);
// 			// console.log("EditTimesheet", res);
// 			fetchData();
// 		} catch (error) {
// 			console.log("Error fetching data", error);
// 		}
// 		setBtnLoaderEdit(false);
// 		// setSelectedProject("");
// 		// setSelectedManager("");
// 		//setTextName("");
// 		setEditPopup(false);
// 	};

// 	const timesheetEdit = (rowIndex) => {
// 		const clickedRow = timesheetDetails[rowIndex];
// 		//console.log("edit popup data", clickedRow);
// 		const id = clickedRow.id;
// 		const statusData = clickedRow.status;

// 		setEditFormData(clickedRow);
// 		// console.log("time", id);
// 		// console.log("object", clickedRow);
// 		setSelectedProject(clickedRow.project);
// 		setSelectedManager(clickedRow.project_manager);
// 		setSelectedWorkModel(clickedRow.work_mode);
// 		setSelectedDate(clickedRow.date);
// 		setSelectedStartTime(clickedRow.start_time);
// 		setSelectedEndTime(clickedRow.end_time);
// 		setSelectedHours(clickedRow.logged_hours);
// 		setSelectedStatus(statusData);
// 		setSelectedId(id);
// 		// console.log(params, "dhgdhsdjsjhdjsdh");
// 		setEditPopup(clickedRow);
// 	};

// 	useEffect(() => {
// 		setSelectedProject("");
// 		setSelectedManager("");
// 		// setSelectedDate('');
// 		setSelectedWorkModel("");
// 		setTextName("");
// 		setSelectedStartTime("");
// 		setSelectedEndTime("");
// 		setSelectedHours("");
// 		setSelectedStatus("");
// 		setNonProductiveHours("");
// 	}, [ButtonPopup]);

// 	const handleNonProductiveChange = (e) => {
// 		setNonProductiveHours(e.target.value);
// 		// console.log("non productive",e.target.value)
// 	};
// 	const handleOtherChange = (e) => {
// 		setSelectedProject("Others");
// 		setSelectedManager(e.target.value);
// 		setTextName(e.target.value);
// 	};

// 	const handleChangeWork = (e) => {
// 		setSelectedWorkModel(e.target.value);
// 	};

// 	const handleChange = (e) => {
// 		const selectedValue = e.target.value;

// 		// console.log("seleteced",selectedValue);

// 		setSelectedProject(selectedValue);
// 		setDropdownValue(selectedValue);

// 		if (selectedValue === "nonproductive" || selectedValue === "Others") {
// 			setTextName("");
// 			setSelectedManager("");
// 		} else {
// 			// const select = parseInt(selectedValue);
// 			const selectedProject = timesheetProjects.find(
// 				(item) => item.label === selectedValue
// 			);

// 			// console.log("seletedProject",selectedProject);

// 			if (selectedProject) {
// 				setTextName(selectedProject.project_manager_name);
// 				// console.log("project_manager", selectedProject);
// 				setSelectedManager(selectedProject.project_manager_name);
// 			} else {
// 				setTextName("");
// 				setSelectedManager("");
// 			}
// 		}
// 	};

// 	const handleBtnColor = (rowIndex) => {
// 		const colorRow = timesheetDetails[rowIndex];
// 		const access = colorRow.access;
// 		if (access === true) {
// 			return "s";
// 		} else {
// 			return "";
// 		}
// 	};
// 	return (
// 		<div className="w-auto my-6 mx-6 py-4 px-2">
// 			<div className="flex flex-wrap flex-col lg:flex-nowrap justify-center p-2">
// 				{ButtonPopup && (
// 					<Popup
// 						popupstyle="md:w-2/5 w-full"
// 						trigger={ButtonPopup}
// 						title="Add Timesheet"
// 						setTrigger={setButtonPopup}
// 					>
// 						<form
// 							className="mt-2 rounded px-4 pt-2 pb-2 mb-2"
// 							onSubmit={handleSave}
// 						>
// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="Project" />
// 								<Dropdown
// 									style="w-full"
// 									options={[
// 										{ value: "", label: "Select" },
// 										...(timesheetProjects
// 											? timesheetProjects.map((row) => ({
// 													value: row.label,
// 													label: row.label,
// 											  }))
// 											: []),
// 										{ value: "Others", label: "Others" },
// 										{ value: "nonproductive", label: "Non Productive" },
// 									]}
// 									onChange={handleChange}
// 									value={selectedProject}
// 									required={true}
// 								/>

// 								{selectedProject === "nonproductive" && (
// 									<div className="mb-4 mt-3 text-sm">
// 										<ProfileLabel label="Non Productive" />
// 										<NumberBox
// 											style="w-full"
// 											type="number"
// 											value={nonProductiveHours}
// 											onChange={handleNonProductiveChange}
// 											required={true}
// 										/>
// 									</div>
// 								)}
								
// 								{selectedProject === "Others" && (
// 									<div className="mb-4 mt-3 text-sm">
// 										<ProfileLabel label="Manager" />
// 										<InputBox
// 											style="w-full"
// 											value={textName}
// 											onChange={handleOtherChange}
// 											required={true}
// 										/>
// 									</div>
// 								)}

// 								{selectedProject !== "nonproductive" &&
// 									selectedProject !== "Others" && (
// 										<div className="mb-4 mt-3">
// 											<ProfileLabel label="Manager" />
// 											<InputBox style="w-full" value={textName} on readOnly />
// 										</div>
// 									)}
// 							</div>
// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="Work Mode" />
// 								<Dropdown
// 									style="w-full"
// 									options={TimesheetWorkModel}
// 									onChange={handleChangeWork}
// 									value={selectedWorkModel}
// 									required={true}
// 								/>
// 							</div>
// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="Date" />
// 								<DateBox
// 									style="w-full"
// 									placeholder="Date"
// 									value={currentDate}
// 									disabled={true}
// 									type="date"
// 								/>
// 							</div>
// 							<div className="mb-4 text-sm ">
// 								<ProfileLabel label="Start Time" />
// 								<input
// 									type="time"
// 									className="shadow bg-transparent appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline timefield"
// 									value={selectedStartTime}
// 									onChange={handleStartTimeChange}
// 									required
// 								/>
// 							</div>

// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="End Time" />
// 								<input
// 									type="time"
// 									className="shadow bg-transparent appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline timefield"
// 									value={selectedEndTime}
// 									onChange={handleEndTimeChange}
// 									required
// 								/>
// 							</div>
// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="Logged Hours" />
// 								<NumberBox
// 									style="w-full"
// 									type="number"
// 									onChange={(e) => setSelectedHours(e.target.value)}
// 									value={selectedHours}
// 									required={true}
// 								/>
// 							</div>
// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="Status" />
// 								<Textarea
// 									style="w-full h-24"
// 									onChange={(e) => setSelectedStatus(e.target.value)}
// 									value={selectedStatus}
// 									required={true}
// 								/>
// 							</div>
// 							<div className="flex justify-center">
// 								{btnLoader ? (
// 									<Loader />
// 								) : (
// 									<Button classname="save-button py-2 px-4 rounded">
// 										Save
// 									</Button>
// 								)}
// 							</div>
// 						</form>
// 					</Popup>
// 				)}

// 				{editPopup && (
// 					<Popup
// 						trigger={editPopup}
// 						title="Edit Timesheet"
// 						setTrigger={setEditPopup}
// 						popupstyle="md:w-2/5 w-full"
// 					>
// 						<form
// 							className="mt-2 rounded px-4 pt-2 pb-2 mb-2"
// 							onSubmit={handleSaveEdit}
// 						>
// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="Project" />
// 								<Dropdown
// 									style="w-full"
// 									options={[
// 										{ value: "", label: "Select" },
// 										...(timesheetProjects
// 											? timesheetProjects.map((row) => ({
// 													value: row.label,
// 													label: row.label,
// 											  }))
// 											: []),
// 										{ value: "Others", label: "Others" },
// 										{ value: "nonproductive", label: "Non Productive" },
// 									]}
// 									onChange={handleChange}
// 									value={selectedProject}
// 									required={true}
// 								/>

// 								{selectedProject === "nonproductive" && (
// 									<div className="mb-4 mt-3 text-sm">
// 										<ProfileLabel label="Non Productive" />
// 										<NumberBox
// 											style="w-full"
// 											type="number"
// 											value={nonProductiveHours}
// 											onChange={handleNonProductiveChange}
// 											required={true}
// 										/>
// 									</div>
// 								)}

// 								{selectedProject === "Others" && (
// 									<div className="mb-4 mt-3 text-sm">
// 										<ProfileLabel label="Manager" />
// 										<InputBox
// 											style="w-full"
// 											value={textName}
// 											onChange={handleOtherChange}
// 											required={true}
// 										/>
// 									</div>
// 								)}

// 								{selectedProject !== "nonproductive" &&
// 									selectedProject !== "Others" && (
// 										<div className="mb-4 mt-3 text-sm">
// 											<ProfileLabel label="Manager" />
// 											<InputBox
// 												style="w-full"
// 												value={selectedManager}
// 												readOnly={true}
// 											/>
// 										</div>
// 									)}
// 							</div>
// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="Work Mode" />
// 								<Dropdown
// 									style="w-full"
// 									options={TimesheetWorkModel}
// 									onChange={handleChangeWork}
// 									value={selectedWorkModel}
// 									required={true}
// 								/>
// 							</div>

// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="Date" />
// 								<DateBox
// 									style="w-full"
// 									placeholder="Date"
// 									value={selectedDate}
// 									disabled={true}
// 									type="date"
// 									required={true}
// 								/>
// 							</div>
// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="Start Time" />
// 								<input
// 									type="time"
// 									className="shadow bg-transparent appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline timefield"
// 									value={selectedStartTime}
// 									onChange={handleStartTimeChange}
// 									required
// 								/>
// 							</div>
// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="End Time" />
// 								<input
// 									type="time"
// 									className="shadow bg-transparent appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline timefield"
// 									value={selectedEndTime}
// 									onChange={handleEndTimeChange}
// 									required
// 								/>
// 							</div>
// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="Logged Hours" />
// 								<NumberBox
// 									style="w-full"
// 									type="number"
// 									onChange={(e) => setSelectedHours(e.target.value)}
// 									value={selectedHours}
// 									required={true}
// 								/>
// 							</div>
// 							<div className="mb-4 text-sm">
// 								<ProfileLabel label="Status" />
// 								<Textarea
// 									style="w-full h-24"
// 									onChange={(e) => setSelectedStatus(e.target.value)}
// 									value={selectedStatus}
// 									required={true}
// 								/>
// 							</div>

// 							<div className="flex justify-center">
// 								{btnLoaderEdit ? (
// 									<Loader />
// 								) : (
// 									<Button classname="save-button py-2 px-4 rounded bg-blue-700">
// 										Save
// 									</Button>
// 								)}
// 							</div>
// 						</form>
// 					</Popup>
// 				)}

// 				<div className="flex justify-end mr-5">
// 					<Button
// 						onClick={addTimeSheet}
// 						classname="bg-button text-white font-semibold px-3 py-2 rounded-md"
// 					>
// 						AddTimesheet
// 					</Button>
// 				</div>
// 				{/* {console.log("timesheetDetails", timesheetDetails)} */}
// 				{loading ? (
// 					<div className="w-full h-[70vh] flex items-center justify-center">
// 						<Loader />
// 					</div>
// 				) : user.user_role === "EMPLOYEE" ||
// 				  user.user_role === "INTERN" ||
// 				  user.user_role === "MANAGER" ||
// 				  user.user_role === "TRAINEE" ||
// 				  user.user_role === "RMG" ||
// 				  user.user_role === "CONSULTANT" ? (
// 					timesheetDetails && timesheetDetails.length > 0 ? (
// 						<>
// 							<Table
// 								tableStyle="border-spacing-y-[10px] border-separate -mt-4"
// 								bodyStyle="bg-accent box-shadow"
// 								header={timesheetTableHead}
// 								body={timesheetDetails.map((row) => [
// 									row.project,
// 									row.project_manager,
// 									row.date,
// 									row.start_time,
// 									row.end_time,
// 									row.logged_hours,
// 									row.project === "Non Productive" ? row.non_productive_hrs : 0,
// 									<span className="truncate max-w-[150px] inline-block">
// 										{row.status}
// 									</span>,
// 								])}
// 								bodyTdStyle="table-body-td intro-x"
// 								headTdStyle="table-body-td intro-x"
// 								btnTitle="Edit"
// 								buttonStyleOne={handleBtnColor}
// 								buttonStyleOneData={true}
// 								btnstyle="intro-x"
// 								onClick={(rowIndex) => timesheetEdit(rowIndex)}
// 							/>
// 						</>
// 					) : (
// 						<h4 className="text-center p-4 font-semibold">No Data</h4>
// 					)
// 				) : null}
// 			</div>
// 		</div>
// 	);
// };

// export default Timesheet;




import React, { useState, useContext, useEffect } from "react";
import Dropdown from "./Dropdown";
import Popup from "./Popup";
import Table from "./Table";
import ProfileLabel from "./ProfileLabel";
import InputBox from "./InputBox";
import DateBox from "./DateBox";
import NumberBox from "./NumberBox";
import Textarea from "./Textarea";
import Button from "./Button";
import {
	timesheetTableHead,
	timesheetTableBody,
	TimesheetWorkModel,
} from "../data";
import { TIMESHEET } from "../Constants";
import { TIMESHEETEDIT } from "../Constants";
import ApiCall from "../utils/ApiCall";
import AuthContext from "../contexts/AuthContext";
import SweetAlert from "../utils/SweetAlert";
import Loader from "./Loader";

const Timesheet = () => {
	const { authTokens, user } = useContext(AuthContext);
	const [currentDate] = useState(getFormattedDate());
	const [loading, setLoading] = useState(true);
	const [btnLoader, setBtnLoader] = useState(false);
	const [btnLoaderEdit, setBtnLoaderEdit] = useState(false);
	const [selectedProject, setSelectedProject] = useState("");
	const [selectedManager, setSelectedManager] = useState("");
	const [selectedWorkModel, setSelectedWorkModel] = useState("");
	const [selectedStatus, setSelectedStatus] = useState("");
	const [selectedDate, setSelectedDate] = useState("");
	const [selectedHours, setSelectedHours] = useState("");
	const [selectedStartTime, setSelectedStartTime] = useState("");
	const [selectedEndTime, setSelectedEndTime] = useState("");
	const [ButtonPopup, setButtonPopup] = useState(false);
	const [editPopup, setEditPopup] = useState(null);
	const [timesheetDetails, setTimesheetDetails] = useState([]);
	const [timesheetProjects, setTimesheetProjects] = useState([]);
	const [dropDownValue, setDropdownValue] = useState(null);
	const [textName, setTextName] = useState("");
	const [editFormData, setEditFormData] = useState([]);
	const [selectedId, setSelectedId] = useState(" ");
	const [nonProductiveHours, setNonProductiveHours] = useState(0);
	const [groupedTimesheets, setGroupedTimesheets] = useState([]);

	const [managersList, setManagersList] = useState([]);

	// New state for multiple projects
	const [multipleProjects, setMultipleProjects] = useState([
		{
			id: 1,
			project: "",
			manager: "",
			workModel: "",
			startTime: "",
			endTime: "",
			hours: "",
			status: "",
			textName: "",
			nonProductiveHours: 0,
		},
	]);

	// New state for multiple projects in edit mode
	const [multipleEditProjects, setMultipleEditProjects] = useState([
		{
			id: 1,
			project: "",
			manager: "",
			workModel: "",
			startTime: "",
			endTime: "",
			hours: "",
			status: "",
			textName: "",
			nonProductiveHours: 0,
			originalId: null,
		},
	]);

	useEffect(() => {
		fetchData();
		setTimesheetProjects([]);
	}, []);

	const fetchData = async () => {
    try {
        const data = await ApiCall(TIMESHEET, "GET", authTokens, null);
        setTimesheetDetails(data.data.timesheet_data);
        setGroupedTimesheets(groupTimesheetsByDate(data.data.timesheet_data));
        
        // ✅ Transform projects - handle nested project_manager object
        const transformedProjects = data.data.projects
            .filter(project => project.project_name !== null)
            .map(project => ({
                id: project.id,
                label: project.project_name,
                project_manager_name: project.project_manager?.name || "Not Assigned",
                project_manager_id: project.project_manager?.id || null
            }));
        
        setTimesheetProjects(transformedProjects);
        
        // ✅ Extract unique managers from nested object
        const uniqueManagers = [...new Set(
            data.data.projects
                .filter(project => project.project_manager && project.project_manager.name)
                .map(project => project.project_manager.name)
        )];
        
        setManagersList(
            uniqueManagers.map(manager => ({ 
                value: manager, 
                label: manager 
            }))
        );
        
        setSelectedId(data.id);
        setLoading(false);
    } catch (error) {
        console.log("Error fetching data", error);
        setLoading(false);
    }
};

	const groupTimesheetsByDate = (timesheets) => {
		const grouped = timesheets.reduce((acc, timesheet) => {
			const date = timesheet.date;
			if (!acc[date]) {
				acc[date] = [];
			}
			acc[date].push(timesheet);
			return acc;
		}, {});
	
		// Convert to array format for table display
		return Object.keys(grouped).map(date => {
			const projects = grouped[date];
			const totalHours = projects.reduce((sum, project) => sum + parseFloat(project.logged_hours || 0), 0);
			const totalNonProductiveHours = projects.reduce((sum, project) => {
				return sum + parseFloat(project.project === "Non Productive" ? project.non_productive_hrs || 0 : 0);
			}, 0);
			
			return {
				date,
				projects,
				totalHours,
				totalNonProductiveHours,
				// Use first project's data for display (or combine as needed)
				firstProject: projects[0],
				projectCount: projects.length
			};
		});
	};

	function getFormattedDate() {
		const date = new Date();
		const year = date.getFullYear();
		let month = date.getMonth() + 1;
		let day = date.getDate();

		month = month < 10 ? `0${month}` : month;
		day = day < 10 ? `0${day}` : day;

		return `${year}-${month}-${day}`;
	}

	// Add new project row for edit mode
	const addNewEditProject = () => {
		const newProject = {
			id: multipleEditProjects.length + 1,
			project: "",
			manager: "",
			workModel: "",
			startTime: "",
			endTime: "",
			hours: "",
			status: "",
			textName: "",
			nonProductiveHours: 0,
			originalId: null,
		};
		setMultipleEditProjects([...multipleEditProjects, newProject]);
	};

	// Remove project row for edit mode
	const removeEditProject = (projectId) => {
		if (multipleEditProjects.length > 1) {
			setMultipleEditProjects(multipleEditProjects.filter((project) => project.id !== projectId));
		}
	};

	// Update project field for edit mode
	const updateEditProjectField = (projectId, field, value) => {
		setMultipleEditProjects(
			multipleEditProjects.map((project) => {
				if (project.id === projectId) {
					const updatedProject = { ...project, [field]: value };
					
					// Handle project selection logic
					if (field === "project") {
						if (value === "nonproductive" || value === "Others") {
							updatedProject.textName = "";
							updatedProject.manager = "";
						} else {
							const selectedProject = timesheetProjects.find(
								(item) => item.label === value
							);
							if (selectedProject) {
								updatedProject.textName = selectedProject.project_manager_name;
								updatedProject.manager = selectedProject.project_manager_name;
							} else {
								updatedProject.textName = "";
								updatedProject.manager = "";
							}
						}
					}
					
					// Handle other text input for manager
					if (field === "textName" && project.project === "Others") {
						updatedProject.manager = value;
					}
					
					return updatedProject;
				}
				return project;
			})
		);
	};

	// Add new project row
	const addNewProject = () => {
		const newProject = {
			id: multipleProjects.length + 1,
			project: "",
			manager: "",
			workModel: "",
			startTime: "",
			endTime: "",
			hours: "",
			status: "",
			textName: "",
			nonProductiveHours: 0,
		};
		setMultipleProjects([...multipleProjects, newProject]);
	};

	// Remove project row
	const removeProject = (projectId) => {
		if (multipleProjects.length > 1) {
			setMultipleProjects(multipleProjects.filter((project) => project.id !== projectId));
		}
	};

	// Update project field
	const updateProjectField = (projectId, field, value) => {
		setMultipleProjects(
			multipleProjects.map((project) => {
				if (project.id === projectId) {
					const updatedProject = { ...project, [field]: value };
					
					// Handle project selection logic
					if (field === "project") {
						if (value === "nonproductive" || value === "Others") {
							updatedProject.textName = "";
							updatedProject.manager = "";
						} else {
							const selectedProject = timesheetProjects.find(
								(item) => item.label === value
							);
							if (selectedProject) {
								updatedProject.textName = selectedProject.project_manager_name;
								updatedProject.manager = selectedProject.project_manager_name;
							} else {
								updatedProject.textName = "";
								updatedProject.manager = "";
							}
						}
					}
					
					// Handle other text input for manager
					if (field === "textName" && project.project === "Others") {
						updatedProject.manager = value;
					}
					
					return updatedProject;
				}
				return project;
			})
		);
	};

	const addTimeSheet = () => {
		setButtonPopup(true);
	};

	const handleSaveEditMultiple = async (event) => {
    event.preventDefault();
    setBtnLoaderEdit(true);

    try {
        const clickedGroup = groupedTimesheets.find(g => g.date === selectedDate);
        const originalProjectIds = clickedGroup.projects.map(p => p.id);
        const currentProjectIds = multipleEditProjects
            .filter(p => p.originalId)
            .map(p => p.originalId);
        
        // Find IDs to delete (original projects that are no longer in the edit form)
        const idsToDelete = originalProjectIds.filter(id => !currentProjectIds.includes(id));
        
        // STEP 1: Delete removed projects first
        if (idsToDelete.length > 0) {
            const deletePromises = idsToDelete.map(id => 
                ApiCall(`${TIMESHEETEDIT}?id=${id}`, "DELETE", authTokens, null)
            );
            await Promise.all(deletePromises);
        }

        // Separate new projects from existing ones
        const newProjects = multipleEditProjects.filter(project => !project.originalId);
        const existingProjects = multipleEditProjects.filter(project => project.originalId);

        // STEP 2: Update existing projects (use the LAST one to trigger the delete logic)
        const existingProjectPromises = existingProjects.map(async (project, index) => {
            const params = {
                id: project.originalId,
                project_name: project.project,
                project_manager: project.project === "nonproductive" ? "None" : project.manager,
                work_mode: project.workModel,
                date: selectedDate,
                start_time: project.startTime,
                end_time: project.endTime,
                logged_hours: project.hours,
                status: project.status,
                non_productive_hrs: project.nonProductiveHours,
                // Add a flag to prevent deletion on all but the last update
                skip_delete: index < existingProjects.length - 1
            };
            return await ApiCall(TIMESHEETEDIT, "POST", authTokens, params);
        });

        const existingResults = await Promise.all(existingProjectPromises);

        // STEP 3: Create new projects AFTER existing ones are updated
        const newProjectPromises = newProjects.map(async (project) => {
            const params = {
                project_name: project.project,
                project_manager: project.project === "nonproductive" ? "None" : project.manager,
                work_mode: project.workModel,
                date: selectedDate,
                start_time: project.startTime,
                end_time: project.endTime,
                logged_hours: project.hours,
                status: project.status,
                non_productive_hrs: project.nonProductiveHours,
            };
            return await ApiCall(TIMESHEET, "POST", authTokens, params);
        });

        const newResults = await Promise.all(newProjectPromises);

        // Combine results
        const allResults = [...existingResults, ...newResults];
        
        // Check if all requests were successful
        const allSuccessful = allResults.every((res) => res.status === 200);
        const hasConflicts = allResults.some((res) => res.status === 409);

        if (allSuccessful) {
            SweetAlert({ title: "All timesheets updated successfully", icon: "success" });
        } else if (hasConflicts) {
            SweetAlert({ title: "Some entries have conflicts", icon: "warning" });
        } else {
            SweetAlert({ title: "Some entries failed to update", icon: "error" });
        }

        await fetchData();
    } catch (error) {
        console.log("Error updating multiple projects", error);
        SweetAlert({ title: "Error updating timesheets", icon: "error" });
    }

    setBtnLoaderEdit(false);
    setEditPopup(false);
    
    // Reset edit form
    setMultipleEditProjects([
        {
            id: 1,
            project: "",
            manager: "",
            workModel: "",
            startTime: "",
            endTime: "",
            hours: "",
            status: "",
            textName: "",
            nonProductiveHours: 0,
            originalId: null,
        },
    ]);
};

	const handleSaveMultiple = async (event) => {
		event.preventDefault();
		setBtnLoader(true);

		try {
			const promises = multipleProjects.map(async (project) => {
				const params = {
					project_name: project.project,
					project_manager: project.project === "nonproductive" ? "None" : project.manager,
					work_mode: project.workModel,
					date: currentDate,
					start_time: project.startTime,
					end_time: project.endTime,
					logged_hours: project.hours,
					status: project.status,
					non_productive_hrs: project.nonProductiveHours,
				};

				return await ApiCall(TIMESHEET, "POST", authTokens, params);
			});

			const results = await Promise.all(promises);
			
			// Check if all requests were successful
			const allSuccessful = results.every((res) => res.status === 200);
			const hasConflicts = results.some((res) => res.status === 409);

			if (allSuccessful) {
				SweetAlert({ title: "All timesheets added successfully", icon: "success" });
			} else if (hasConflicts) {
				SweetAlert({ title: "Some entries have conflicts", icon: "warning" });
			} else {
				SweetAlert({ title: "Some entries failed to save", icon: "error" });
			}

			await fetchData();
		} catch (error) {
			console.log("Error saving multiple projects", error);
			SweetAlert({ title: "Error saving timesheets", icon: "error" });
		}

		setBtnLoader(false);
		setButtonPopup(false);
		
		// Reset form
		setMultipleProjects([
			{
				id: 1,
				project: "",
				manager: "",
				workModel: "",
				startTime: "",
				endTime: "",
				hours: "",
				status: "",
				textName: "",
				nonProductiveHours: 0,
			},
		]);
	};

	const handleSave = async (event) => {
		event.preventDefault();
		setBtnLoader(true);

		const params = {
			project_name: selectedProject,
			project_manager:
				selectedProject === "nonproductive" ? "None" : selectedManager,
			work_mode: selectedWorkModel,
			date: currentDate,
			start_time: selectedStartTime,
			end_time: selectedEndTime,
			logged_hours: selectedHours,
			status: selectedStatus,
			non_productive_hrs: nonProductiveHours,
		};

		try {
			const res = await ApiCall(TIMESHEET, "POST", authTokens, params);
			await fetchData();
			if (res.status === 200) {
				SweetAlert({ title: res.data.message, icon: "success" });
			} else if (res.status === 409) {
				SweetAlert({
					title: res.data.message,
					icon: "error",
				});
			} else {
				SweetAlert({ title: "Something went wrong", icon: "error" });
			}
		} catch (error) {
			console.log("Error fetching data", error);
		}
		setBtnLoader(false);
		setButtonPopup(false);
		setSelectedProject("");
		fetchData();
	};

	const handleStartTimeChange = (event) => {
		const time = event.target.value;
		setSelectedStartTime(time);
	};

	const handleEndTimeChange = (event) => {
		const time = event.target.value;
		setSelectedEndTime(time);
	};

	const handleSaveEdit = async (event) => {
		event.preventDefault();
		setBtnLoaderEdit(true);
		const params = {
			id: selectedId,
			project_name: selectedProject,
			project_manager:
				selectedProject === "nonproductive" ? "None" : selectedManager,
			work_mode: selectedWorkModel,
			date: selectedDate,
			start_time: selectedStartTime,
			end_time: selectedEndTime,
			logged_hours: selectedHours,
			status: selectedStatus,
			non_productive_hrs: nonProductiveHours,
		};

		try {
			const res = await ApiCall(TIMESHEETEDIT, "POST", authTokens, params);
			setButtonPopup(false);
			if (res.status === 200) {
				SweetAlert({ title: "Edited timesheet added", icon: "success" });
			} else {
				SweetAlert({ title: "Something went wrong", icon: "error" });
			}
			fetchData();
		} catch (error) {
			console.log("Error fetching data", error);
		}
		setBtnLoaderEdit(false);
		setEditPopup(false);
	};

	const timesheetEdit = (rowIndex) => {
		const clickedGroup = groupedTimesheets[rowIndex];
		const projects = clickedGroup.projects;
		
		// Set the date for editing
		setSelectedDate(clickedGroup.date);
		
		// Initialize edit form with all projects for this date
		const editProjects = projects.map((project, index) => ({
			id: index + 1,
			project: project.project,
			manager: project.project_manager,
			workModel: project.work_mode,
			startTime: project.start_time,
			endTime: project.end_time,
			hours: project.logged_hours,
			status: project.status,
			textName: project.project_manager,
			nonProductiveHours: project.non_productive_hrs || 0,
			originalId: project.id,
		}));
		
		setMultipleEditProjects(editProjects);
		setEditPopup(clickedGroup);
	};
	

	useEffect(() => {
		setSelectedProject("");
		setSelectedManager("");
		setSelectedWorkModel("");
		setTextName("");
		setSelectedStartTime("");
		setSelectedEndTime("");
		setSelectedHours("");
		setSelectedStatus("");
		setNonProductiveHours("");
	}, [ButtonPopup]);

	const handleNonProductiveChange = (e) => {
		setNonProductiveHours(e.target.value);
	};

	const handleOtherChange = (e) => {
		setSelectedProject("Others");
		setSelectedManager(e.target.value);
		setTextName(e.target.value);
	};

	const handleChangeWork = (e) => {
		setSelectedWorkModel(e.target.value);
	};

	const handleChange = (e) => {
		const selectedValue = e.target.value;
		setSelectedProject(selectedValue);
		setDropdownValue(selectedValue);

		if (selectedValue === "nonproductive" || selectedValue === "Others") {
			setTextName("");
			setSelectedManager("");
		} else {
			const selectedProject = timesheetProjects.find(
				(item) => item.label === selectedValue
			);

			if (selectedProject) {
				setTextName(selectedProject.project_manager_name);
				setSelectedManager(selectedProject.project_manager_name);
			} else {
				setTextName("");
				setSelectedManager("");
			}
		}
	};

	const handleBtnColor = (rowIndex) => {
		const colorRow = timesheetDetails[rowIndex];
		const access = colorRow.access;
		if (access === true) {
			return "s";
		} else {
			return "";
		}
	};

	return (
		<div className="w-auto my-6 mx-6 py-4 px-2">
			<div className="flex flex-wrap flex-col lg:flex-nowrap justify-center p-2">
				{ButtonPopup && (
					<Popup
						popupstyle="md:w-4/5 w-full max-h-[90vh] overflow-y-auto"
						trigger={ButtonPopup}
						title="Add Multiple Timesheets"
						setTrigger={setButtonPopup}
					>
						<form
							className="mt-2 rounded px-4 pt-2 pb-2 mb-2"
							onSubmit={handleSaveMultiple}
						>
							<div className="space-y-6">
								{multipleProjects.map((project, index) => (
									<div key={project.id} className="border rounded-lg p-4 bg-gray-50">
										<div className="flex justify-between items-center mb-4">
											<h4 className="text-lg font-semibold">Project {index + 1}</h4>
											{multipleProjects.length > 1 && (
												<Button
													type="button"
													onClick={() => removeProject(project.id)}
													classname="bg-red-500 text-white px-3 py-1 rounded text-sm"
												>
													Remove
												</Button>
											)}
										</div>

										<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
											<div className="text-sm">
												<ProfileLabel label="Project" />
												<Dropdown
													style="w-full"
													options={[
														{ value: "", label: "Select" },
														...(timesheetProjects
															? timesheetProjects.map((row) => ({
																	value: row.label,
																	label: row.label,
															  }))
															: []),
														{ value: "Others", label: "Others" },
														{ value: "nonproductive", label: "Non Productive" },
													]}
													onChange={(e) => updateProjectField(project.id, "project", e.target.value)}
													value={project.project}
													required={true}
												/>
											</div>

											<div className="text-sm">
												<ProfileLabel label="Work Mode" />
												<Dropdown
													style="w-full"
													options={TimesheetWorkModel}
													onChange={(e) => updateProjectField(project.id, "workModel", e.target.value)}
													value={project.workModel}
													required={true}
												/>
											</div>

											{project.project === "nonproductive" && (
												<div className="text-sm">
													<ProfileLabel label="Non Productive Hours" />
													<NumberBox
														style="w-full"
														type="number"
														value={project.nonProductiveHours}
														onChange={(e) => updateProjectField(project.id, "nonProductiveHours", e.target.value)}
														required={true}
													/>
												</div>
											)}

											{project.project === "Others" && (
												<div className="text-sm">
													<ProfileLabel label="Manager" />
													<Dropdown
														style="w-full"
														options={[
															{ value: "", label: "Select Manager" },
															...managersList
														]}
														onChange={(e) => updateProjectField(project.id, "textName", e.target.value)}
														value={project.textName}
														required={true}
													/>
												</div>
											)}

											

											{project.project !== "nonproductive" && project.project !== "Others" && project.project !== "" && (
												<div className="text-sm">
													<ProfileLabel label="Manager" />
													<InputBox 
														style="w-full" 
														value={project.textName} 
														readOnly 
													/>
												</div>
											)}

											<div className="text-sm">
												<ProfileLabel label="Start Time" />
												<input
													type="time"
													className="shadow bg-transparent appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline timefield"
													value={project.startTime}
													onChange={(e) => updateProjectField(project.id, "startTime", e.target.value)}
													required
												/>
											</div>

											<div className="text-sm">
												<ProfileLabel label="End Time" />
												<input
													type="time"
													className="shadow bg-transparent appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline timefield"
													value={project.endTime}
													onChange={(e) => updateProjectField(project.id, "endTime", e.target.value)}
													required
												/>
											</div>

											<div className="text-sm">
												<ProfileLabel label="Logged Hours" />
												<NumberBox
													style="w-full"
													type="number"
													onChange={(e) => updateProjectField(project.id, "hours", e.target.value)}
													value={project.hours}
													required={true}
												/>
											</div>

											<div className="text-sm md:col-span-2">
												<ProfileLabel label="Status" />
												<Textarea
													style="w-full h-24"
													onChange={(e) => updateProjectField(project.id, "status", e.target.value)}
													value={project.status}
													required={true}
												/>
											</div>
										</div>
									</div>
								))}
							</div>

							<div className="flex justify-between mt-6">
								<Button
									type="button"
									onClick={addNewProject}
									classname="bg-green-500 text-white px-4 py-2 rounded"
								>
									Add Another Project
								</Button>

								<div className="flex justify-center">
									{btnLoader ? (
										<Loader />
									) : (
										<Button classname="save-button py-2 px-4 rounded">
											Save All
										</Button>
									)}
								</div>
							</div>
						</form>
					</Popup>
				)}

				{/* Edit popup with multiple projects support */}
				{editPopup && (
					<Popup
						trigger={editPopup}
						title="Edit Multiple Timesheets"
						setTrigger={setEditPopup}
						popupstyle="md:w-4/5 w-full max-h-[90vh] overflow-y-auto"
					>
						<form
							className="mt-2 rounded px-4 pt-2 pb-2 mb-2"
							onSubmit={handleSaveEditMultiple}
						>
							<div className="space-y-6">
								{multipleEditProjects.map((project, index) => (
									<div key={project.id} className="border rounded-lg p-4 bg-gray-50">
										<div className="flex justify-between items-center mb-4">
											<h4 className="text-lg font-semibold">
												{project.originalId ? `Edit Project ${index + 1}` : `New Project ${index + 1}`}
											</h4>
											{multipleEditProjects.length > 1 && (
												<Button
													type="button"
													onClick={() => removeEditProject(project.id)}
													classname="bg-red-500 text-white px-3 py-1 rounded text-sm"
												>
													Remove
												</Button>
											)}
										</div>

										<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
											<div className="text-sm">
												<ProfileLabel label="Project" />
												<Dropdown
													style="w-full"
													options={[
														{ value: "", label: "Select" },
														...(timesheetProjects
															? timesheetProjects.map((row) => ({
																	value: row.label,
																	label: row.label,
															  }))
															: []),
														{ value: "Others", label: "Others" },
														{ value: "nonproductive", label: "Non Productive" },
													]}
													onChange={(e) => updateEditProjectField(project.id, "project", e.target.value)}
													value={project.project}
													required={true}
												/>
											</div>

											<div className="text-sm">
												<ProfileLabel label="Work Mode" />
												<Dropdown
													style="w-full"
													options={TimesheetWorkModel}
													onChange={(e) => updateEditProjectField(project.id, "workModel", e.target.value)}
													value={project.workModel}
													required={true}
												/>
											</div>

											{project.project === "nonproductive" && (
												<div className="text-sm">
													<ProfileLabel label="Non Productive Hours" />
													<NumberBox
														style="w-full"
														type="number"
														value={project.nonProductiveHours}
														onChange={(e) => updateEditProjectField(project.id, "nonProductiveHours", e.target.value)}
														required={true}
													/>
												</div>
											)}

											{project.project === "Others" && (
												<div className="text-sm">
													<ProfileLabel label="Manager" />
													<Dropdown
														style="w-full"
														options={[
															{ value: "", label: "Select Manager" },
															...managersList
														]}
														onChange={(e) => updateEditProjectField(project.id, "textName", e.target.value)}
														value={project.textName}
														required={true}
													/>
												</div>
											)}

											

											{project.project !== "nonproductive" && project.project !== "Others" && project.project !== "" && (
												<div className="text-sm">
													<ProfileLabel label="Manager" />
													<InputBox 
														style="w-full" 
														value={project.textName} 
														readOnly 
													/>
												</div>
											)}

											<div className="text-sm">
												<ProfileLabel label="Date" />
												<DateBox
													style="w-full"
													placeholder="Date"
													value={selectedDate}
													disabled={true}
													type="date"
													required={true}
												/>
											</div>

											<div className="text-sm">
												<ProfileLabel label="Start Time" />
												<input
													type="time"
													className="shadow bg-transparent appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline timefield"
													value={project.startTime}
													onChange={(e) => updateEditProjectField(project.id, "startTime", e.target.value)}
													required
												/>
											</div>

											<div className="text-sm">
												<ProfileLabel label="End Time" />
												<input
													type="time"
													className="shadow bg-transparent appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline timefield"
													value={project.endTime}
													onChange={(e) => updateEditProjectField(project.id, "endTime", e.target.value)}
													required
												/>
											</div>

											<div className="text-sm">
												<ProfileLabel label="Logged Hours" />
												<NumberBox
													style="w-full"
													type="number"
													onChange={(e) => updateEditProjectField(project.id, "hours", e.target.value)}
													value={project.hours}
													required={true}
												/>
											</div>

											<div className="text-sm md:col-span-2">
												<ProfileLabel label="Status" />
												<Textarea
													style="w-full h-24"
													onChange={(e) => updateEditProjectField(project.id, "status", e.target.value)}
													value={project.status}
													required={true}
												/>
											</div>
										</div>
									</div>
								))}
							</div>

							<div className="flex justify-between mt-6">
								<Button
									type="button"
									onClick={addNewEditProject}
									classname="bg-green-500 text-white px-4 py-2 rounded"
								>
									Add Another Project
								</Button>

								<div className="flex justify-center">
									{btnLoaderEdit ? (
										<Loader />
									) : (
										<Button classname="save-button py-2 px-4 rounded bg-blue-700">
											Save All Changes
										</Button>
									)}
								</div>
							</div>
						</form>
					</Popup>
				)}

				<div className="flex justify-end mr-5">
					<Button
						onClick={addTimeSheet}
						classname="bg-button text-white font-semibold px-3 py-2 rounded-md"
					>
						AddTimesheet
					</Button>
				</div>

				{loading ? (
					<div className="w-full h-[70vh] flex items-center justify-center">
						<Loader />
					</div>
				) : user.user_role === "EMPLOYEE" ||
				user.user_role === "INTERN" ||
				user.user_role === "MANAGER" ||
				user.user_role === "TRAINEE" ||
				user.user_role === "RMG" ||
				user.user_role === "CONSULTANT" ? (
					groupedTimesheets && groupedTimesheets.length > 0 ? (
						<>
							<Table
								tableStyle="border-spacing-y-[10px] border-separate -mt-4"
								bodyStyle="bg-accent box-shadow"
								header={[
									"Date",
									// "Total Projects", 
									"Total Logged Hours",
									// "Total Non-Productive Hours",
									"Project Description",
									"Projects Summary"
								]}
								body={groupedTimesheets.map((group) => [
									group.date,
									// group.projectCount,
									group.totalHours.toFixed(2),
									// group.totalNonProductiveHours.toFixed(2),
									<span className="truncate max-w-[200px] inline-block">
										{group.projects.map(p => p.status).join(", ")}
									</span>,
									<span className="truncate max-w-[200px] inline-block">
										{group.projects.map(p => p.project).join(", ")}
									</span>
								])}
								bodyTdStyle="table-body-td intro-x"
								headTdStyle="table-body-td intro-x"
								btnTitle="Edit"
								buttonStyleOne={handleBtnColor}
								buttonStyleOneData={true}
								btnstyle="intro-x"
								onClick={(rowIndex) => timesheetEdit(rowIndex)}
							/>
						</>
					) : (
						<h4 className="text-center p-4 font-semibold">No Data</h4>
					)
				) : null}
			</div>
		</div>
	);
};

export default Timesheet;